/**
* @name: right-layout-div
* @author: weiyong
* @date: 2023-05-11 18:02
* @description：right-layout-div
* @update: 2023-05-11 18:02
*/
<template>
  <div :class="prefixCls" class="main-panel">
    <MultipleTabs v-if="getShowTabs"/>
    <LayoutContent class="LayoutContent" style="flex:1;" />
    <!-- <right-collect-menu-show v-if="getQuickMenuShow&&systemFlag"/> -->
  </div>
</template>

<script lang="ts">

export default defineComponent({
  components: {},
  name: "right-layout-div",
});
</script>

<script lang="ts" setup>
import {useDesign} from "@/hooks/web/useDesign";
import LayoutContent from '@/layouts/default/content/index.vue';
import {useRootSetting} from "@/hooks/setting/useRootSetting";

import { useFullContent } from '@/hooks/web/useFullContent';
import { useMultipleTabSetting } from '@/hooks/setting/useMultipleTabSetting';
import {defineComponent} from 'vue';
import MultipleTabs from '@/layouts/default/tabs/index.vue';

const { getFullContent } = useFullContent();

const { getShowMultipleTab } = useMultipleTabSetting();

const getShowTabs = computed(() => {
  return unref(getShowMultipleTab) && !unref(getFullContent);
});

const {prefixCls} = useDesign('right-layout-div');

const props=defineProps({
  systemFlag:{}
})
const { getQuickMenuShow } = useRootSetting();
</script>

<style type="text/css" lang="less">
@prefix-cls: ~'@{namespace}-right-layout-div';

.@{prefix-cls} {
  .menu-list-panel{
    .menu-list-li{
      padding: 4px;
      &:hover{
        color:var(--primary-color,#0a6eff);
        cursor:pointer;
      }
    }
  }
  &.main-panel{
    flex: 1;
    overflow: hidden;
  }
  .LayoutContent{
    overflow: hidden !important;
  }
}
</style>
